import styled, { css } from 'styled-components'
import breakpoint from 'theme/breakpoint';

export const ButtonCssHelper = css`
  box-sizing: border-box;
  display: inline-block;
  width: 100%;
  height: 40px;
  padding: 0 ${props => props.theme.paddingM};
  margin: 0;
  font-size: ${props => props.theme.fontSizeS};
  font-weight: ${props => props.theme.fontWeightBold};
  line-height: 40px;
  color: ${props => props.theme.cyan};
  text-align: center;
  letter-spacing: ${props => props.theme.fontSpacingWide};
  cursor: pointer;
  background-color: inherit;
  border: 1px solid ${props => props.theme.cyan};
  border-radius: 2px;
  transition: 0.15s ease-in-out;

  &:hover:enabled {
    outline: none;
    text-decoration: none;
    box-shadow: 0 0 8px 0 rgba(0,0,0,.08),0 0 15px 0 rgba(0,0,0,.02),0 0 20px 4px rgba(0,0,0,.06);
    border-color: ${props => props.theme.hover};
  }
  
  &:disabled {
    cursor: default;
  }
`

export const PrimaryButtonCssHelper = css`
  border: none;
  background-color: ${props => props.theme.buttonBackground};
  color: ${props => props.theme.primaryText};
  
  &:hover {
    background-color: ${props => props.theme.hover};
  }
  &:disabled {
    background-color: ${props => props.theme.disabled};
  }
`

const Button = styled.button`
  // base button
  ${ButtonCssHelper}
  
  ${breakpoint.up('s')`
    width: ${props => props.width || '100%'};
  `}
  
  // primary button
  ${props => props.primary && PrimaryButtonCssHelper}
`

export default Button
